export const CONFIRM_EMAIL = 'CONFIRM_EMAIL';
export const CONFIRM_SUCCESS = 'CONFIRM_SUCCESS';
export const CONFIRM_FAILS = 'CONFIRM_FAILS';
